export default [
  {
    // =============================================================================
    // 관리자 설정 페이지
    // =============================================================================
    path: '/:adminPath/_setting_',
    component: () => import('@/layouts/admin/Index.vue'),
    meta:{
      adminRequired: true
    },
    redirect: '/:adminPath/_setting_/general/basic',
    children: [

      // 관리자 - 환경설정/기본환경설정
      {
        path: 'general/basic',
        name: 'admin_setting_general_basic',
        meta: {
          breadcrumb: [
            {title: ''},
            {title: '환경설정'},
            {
              title: '기본환경설정',
              url: {name: 'admin_setting_basic'},
              active: true
            }
          ],
          pageTitle: '기본환경설정'
        },
        component: () => import('@/views/admin/general/Basic.vue')
      },

      // 관리자 - 환경설정/회원가입설정
      {
        path: 'general/register',
        name: 'admin_setting_general_register',
        meta: {
          breadcrumb: [
            {title: ''},
            {title: '환경설정'},
            {
              title: '회원가입설정',
              url: {name: 'admin_setting_register'},
              active: true
            }
          ],
          pageTitle: '회원가입설정'
        },
        component: () => import('@/views/admin/general/Register.vue')
      },

      // 관리자 - 환경설정/메뉴설정
      {
        path: 'general/menu',
        name: 'admin_setting_general_menu',
        meta: {
          breadcrumb: [
            {title: ''},
            {title: '환경설정'},
            {
              title: '메뉴설정',
              url: {name: 'admin_setting_menu'},
              active: true
            }
          ],
          pageTitle: '메뉴설정'
        },
        component: () => import('@/views/admin/general/Menu.vue')
      },

      // 회원관리 - 리스트
      {
        path: 'member/list',
        name: 'admin_setting_member_list',
        component: () => import('@/views/admin/member/Members.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '일반회원관리',
              url: {name: 'admin_setting_member_list'},
              active: true
            }
          ],
          pageTitle: '일반회원관리'
        }
      },

      // 회원관리 - 상세
      {
        path: 'member/detail',
        name: 'admin_setting_member_detail',
        component: () => import('@/views/admin/member/MemberDetail.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '일반회원관리',
              url: {name: 'page-member'}
            },
            {
              title: '회원상세정보',
              url: {name: 'admin_setting_member_detail'},
              active: true
            }
          ],
          pageTitle: '일반회원관리'
        }
      },

      // 회원관리 - 권한관리
      {
        path: 'member/auth',
        name: 'admin_setting_member_auth',
        component: () => import('@/views/admin/member/MemberAuth.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '권한관리',
              url: {name: 'admin_setting_member_auth'},
              active: true
            }
          ],
          pageTitle: '권한관리'
        }
      },

      // 회원관리 - 권한관리 / 생성
      {
        path: 'member/auth/create',
        name: 'admin_setting_member_auth_create',
        component: () => import('@/views/admin/member/MemberAuthCreated.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '권한관리',
              url: {name: 'admin_setting_member_auth_create'},
              active: true
            }
          ],
          pageTitle: '권한관리'
        }
      },

      // 회원관리 - 권한관리 / 상세
      {
        path: 'member/auth/:id',
        name: 'admin_setting_member_auth_detail',
        component: () => import('@/views/admin/member/MemberAuthDetail.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '권한관리',
              url: {name: 'admin_setting_member_auth_detail'},
              active: true
            }
          ],
          pageTitle: '권한관리'
        }
      },

      // 회원관리 - 메일발송
      {
        path: 'member/sendmail',
        name: 'admin_setting_member_sendmail',
        component: () => import('@/views/admin/member/MemberSendMail.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '메일발송',
              url: {name: 'admin_setting_member_sendmail'},
              active: true
            }
          ],
          pageTitle: '메일발송'
        }
      },
      {
        path: 'member/sendmail/created',
        name: 'admin_setting_member_sendmail_created',
        component: () => import('@/views/admin/member/MemberSendMailDetail.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '메일발송',
              url: {name: 'admin_setting_member_sendmail_created'},
              active: true
            }
          ],
          pageTitle: '메일발송'
        }
      },
      {
        path: 'member/sendmail/:id',
        name: 'admin_setting_member_sendmail_detail',
        component: () => import('@/views/admin/member/MemberSendMailDetail.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: '메일발송',
              url: {name: 'admin_setting_member_sendmail_detail'},
              active: true
            }
          ],
          pageTitle: '메일발송'
        }
      },

      // 회원관리 - SMS발송
      {
        path: 'member/sendsms',
        name: 'admin_setting_member_sendsms',
        component: () => import('@/views/admin/member/MemberSendSMS.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '회원관리'},
            {
              title: 'SMS발송',
              url: {name: 'admin_setting_member_sendsms'},
              active: true
            }
          ],
          pageTitle: 'SMS발송'
        }
      },

      // 게시판관리 - 게시판관리 - 리스트
      {
        path: 'board/list',
        name: 'admin_setting_board_list',
        component: () => import('@/views/admin/board/BoardList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '게시판관리'},
            {
              title: '게시판관리',
              url: {name: 'admin_setting_board_list'},
              active: true
            }
          ],
          pageTitle: '게시판관리'
        }
      },

      // 게시판관리 - 게시판관리 - 등록
      {
        path: 'board/created',
        name: 'admin_setting_board_created',
        component: () => import('@/views/admin/board/BoardCreated.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '게시판관리'},
            {
              title: '게시판등록',
              url: {name: 'admin_setting_board_detail'},
              active: true
            }
          ],
          pageTitle: '게시판등록'
        }
      },

      // 게시판관리 - 게시판관리 - 상세
      {
        path: 'board/:id/update',
        name: 'admin_setting_board_update',
        component: () => import('@/views/admin/board/BoardUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '게시판관리'},
            {
              title: '게시판상세',
              url: {name: 'admin_setting_board_update'},
              active: true
            }
          ],
          pageTitle: '게시판상세'
        }
      },

      // 게시판관리 - 게시판그룹관리
      {
        path: 'board/groups',
        name: 'admin_setting_board_group',
        component: () => import('@/views/admin/board/BoardGroups.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '게시판관리'},
            {
              title: '게시판그룹관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '게시판그룹관리'
        }
      },

      // 팝업관리 - 리스트
      {
        path: 'popup/list',
        name: 'admin_setting_popup_list',
        component: () => import('@/views/admin/popup/AdminPopupList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {
              title: '팝업관리',
              url: {name: 'admin_setting_popup_list'},
              active: true
            }
          ],
          pageTitle: '팝업관리'
        }
      },

      // 팝업관리 - 수정
      {
        path: 'popup/:id/update',
        name: 'admin_setting_popup_update',
        component: () => import('@/views/admin/popup/AdminPopupUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {
              title: '팝업관리',
              url: {name: 'admin_setting_popup_update'},
              active: true
            }
          ],
          pageTitle: '팝업관리'
        }
      },

      // 팝업관리 - 등록
      {
        path: 'popup/created',
        name: 'admin_setting_popup_created',
        component: () => import('@/views/admin/popup/AdminPopupCreated.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '팝업관리'},
            {
              title: '팝업등록',
              url: {name: 'admin_setting_popup_created'},
              active: true
            }
          ],
          pageTitle: '팝업등록'
        }
      },

      // 전자결재 - 사용관리
      {
        path: 'approval/general',
        name: 'admin_setting_approval_general',
        component: () => import('@/views/admin/approval/General.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '전자결재'},
            {
              title: '사용관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '사용관리'
        }
      },

      // 전자결재 - 결재문서관리
      {
        path: 'approval/list',
        name: 'admin_setting_approval_list',
        component: () => import('@/views/admin/approval/Document.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '전자결재'},
            {
              title: '결재문서관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '결재문서관리'
        }
      },

      // 전자결재 - 결재선관리
      {
        path: 'approval/process',
        name: 'admin_setting_approval_approval',
        component: () => import('@/views/admin/approval/Process.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '전자결재'},
            {
              title: '결재선관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '결재선관리'
        }
      },

      // 전자결재 - 양식관리
      {
        path: 'approval/template',
        name: 'admin_setting_approval_template',
        component: () => import('@/views/admin/approval/Template.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '전자결재'},
            {
              title: '양식관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '양식관리'
        }
      },

      // 전자결재 - 부서수신함관리
      {
        path: 'approval/department',
        name: 'admin_setting_approval_department',
        component: () => import('@/views/admin/approval/Department.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '전자결재'},
            {
              title: '부서수신함 관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '부서수신함 관리'
        }
      },

      // 전자결재 - 결재문서 백업관리
      {
        path: 'approval/backup',
        name: 'admin_setting_approval_backup',
        component: () => import('@/views/admin/approval/Backup.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '전자결재'},
            {
              title: '결재문서 백업관리',
              url: {name: 'admin_setting_board_group'},
              active: true
            }
          ],
          pageTitle: '결재문서 백업관리'
        }
      },

      // 통계관리 - 접속자현황
      {
        path: 'info/accessor',
        name: 'admin_setting_info_accessor',
        component: () => import('@/views/admin/info/Accessor.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '통계관리'},
            {
              title: '접속자현황',
              url: {name: 'admin_setting_info_accessor'},
              active: true
            }
          ],
          pageTitle: '접속자현황'
        }
      },

      // 통계관리 - 접속경로
      {
        path: 'info/accesspath',
        name: 'admin_setting_info_accesspath',
        component: () => import('@/views/admin/info/AccessPath.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '통계관리'},
            {
              title: '접속경로',
              url: {name: 'admin_setting_info_accesspath'},
              active: true
            }
          ],
          pageTitle: '접속경로'
        }
      },

      // 통계관리 - OS/브라우저
      {
        path: 'info/accessos',
        name: 'admin_setting_info_accessos',
        component: () => import('@/views/admin/info/AccessOs.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '통계관리'},
            {
              title: 'OS/브라우저',
              url: {name: 'admin_setting_info_accessos'},
              active: true
            }
          ],
          pageTitle: 'OS/브라우저'
        }
      }


    ]
  }
]

